import { useState } from "react";
import { Link } from "react-router-dom";
import { Crown, X, ChevronRight } from "lucide-react";

const KEY = "thanks-stefan-banner-hidden";

export function ThanksStefanBanner() {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden) return null;
  const hide = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div className="relative" data-testid="thanks-stefan-banner">
      <Link to="/danke-stefan" onClick={hide} className="flex items-center gap-4 p-4 pr-12 rounded-3xl bg-gradient-to-br from-rose-50 via-white to-amber-50 ring-1 ring-amber-300 shadow-lg shadow-amber-200/40 active:scale-[0.98] transition-transform">
        <span className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-300 to-rose-400 grid place-items-center shrink-0 shadow"><Crown className="w-7 h-7 text-white" /></span>
        <span className="flex-1 min-w-0">
          <span className="block text-[10px] font-extrabold uppercase tracking-[0.2em] text-amber-600">Von Herzen</span>
          <span className="block font-display text-xl font-black text-slate-900">Danke, Stefan Lageder!</span>
          <span className="block text-xs text-slate-500">Ohne ihn gäbe es unsere Community nicht mehr</span>
        </span>
        <ChevronRight className="w-6 h-6 text-rose-500 shrink-0" />
      </Link>
      <button onClick={hide} aria-label="Ausblenden" data-testid="thanks-stefan-banner-close" className="absolute top-3 right-3 w-8 h-8 rounded-full grid place-items-center text-slate-400 hover:bg-white"><X className="w-4 h-4" /></button>
    </div>
  );
}
